<template>
  <div class="ad-plan-edit">
    <head-panel title="计划管理" subtitle="PLAN MANAGEMENT" :exportExc="false"></head-panel>
    <div class="formPanel">
      <h3 class="subTit"></h3>
      <el-form :model="plan" :rules="rules" ref="plan" label-width="12%" v-loading="loading">
        <h4 class="form-title">计划设置</h4>
        <el-form-item label="属于广告主" prop="advertiser" v-if="platform === 'agency'">
          <ny-select
            :data="planManage.advertiserMenu"
            v-model="plan.advertiser"
            @change="changeSelect"
            type="advertiser"
            placeholder="请选择"
            :filterable="true"
            :disabled="!isAdd"
          ></ny-select>
        </el-form-item>
        <el-form-item label="广告组名称" prop="adGroup">
          <ny-select
            :data="planManage.groupAdverMenu"
            v-model="plan.groupAdver"
            @change="changeSelect"
            :key-value="['id', 'order_name']"
            type="groupAdver"
            placeholder="请选择"
            :filterable="true"
            :disabled="!isAdd"
          ></ny-select>
        </el-form-item>
        <el-form-item label="计划名称" prop="name">
          <el-input v-model="plan.name" class="taskInput" type="age" placeholder="请输入计划名称"></el-input>
        </el-form-item>
        <el-form-item label="结算方式" prop="placeAttr">
          <el-radio-group
            v-model="plan.payment"
            @change="value => handleChange('payment', value)"
            class="rule_form_radio"
            :disabled="!isAdd"
            v-if="plan.payment"
          >
            <el-radio
              :label="item.value"
              v-for="(item, key) in planManage.payments"
              :key="key"
            >{{ item.name }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="优化目标" prop="transformation_target" v-if="isShowTransformation">
          <up-select :disabled="!isAdd" v-model="plan.transformation_target" :key-value="['name', 'id']" :data="transferEventSelect"></up-select>
          <el-link class="ml10"  type="primary" href="https://ad-call.dev.tagtic.cn/docs/docsify/#/conversion">转化事件对接文档</el-link>
        </el-form-item>
        <h4 class="form-title">广告位选择</h4>
        <el-form-item label="流量类型" prop="flowType">
          <el-radio-group
            v-model="plan.flowType"
            @change="flowTypeChange"
            v-if="plan.groupAdver"
            :disabled="!isAdd"
          >
            <el-radio
              :label="item.value"
              v-for="(item, key) in planManage.flowTypeMenu"
              :key="key"
            >{{ item.name }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="投放终端" prop="portType">
          <el-radio-group
            v-model="plan.portType"
            @change="portTypeChange"
            v-if="plan.flowType"
            :disabled="!isAdd"
          >
            <el-radio
              :label="item.value"
              v-for="(item, key) in planManage.portTypeMenu"
              :key="key"
            >{{ item.name }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="广告位属性" prop="placeAttr">
          <el-radio-group
            v-model="plan.placeAttr"
            @change="placeAttrChange"
            class="rule_form_radio"
            v-if="plan.portType"
            :disabled="!isAdd"
          >
            <el-radio
              :label="item.value"
              v-for="(item, key) in planManage.placeAttrMenu"
              :key="key"
            >{{ item.name }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="信息流展示样式" prop="infoStyle" v-if="plan.placeAttr === '2'">
          <el-radio-group
            v-model="plan.infoStyle"
            class="rule_form_radio"
            @change="changeInfoStyle"
            :disabled="!isAdd"
          >
            <el-radio
              :label="item.value"
              v-for="(item, key) in planManage.infoFlowStyles"
              :key="key"
            >{{ item.name }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- <ny-form-item-radio
          required
          label="结算方式"
          prop="payment"
          v-model="plan.payment"
          :data="planManage.payments"
          @change="(value) => handleChange('payment', value)"
        ></ny-form-item-radio>-->
        <el-form-item required label="广告位" prop="place">
          <ny-region-picker
            ref="place"
            :title="placeTitle"
            :datasource="plan.placeAttr ? planManage.placeMenu : []"
            v-model="plan.place"
            :isSelectAll="false"
            :formated-value.sync="formatedValue.place"
            @change="value => handleChange('place', value)"
          ></ny-region-picker>
        </el-form-item>
        <h4 class="form-title">定向</h4>
        <el-form-item required label="投放地域" prop="area">
          <ny-region-picker
            ref="area"
            :datasource="planManage.areaMenu"
            v-model="plan.area"
            :formated-value.sync="formatedValue.area"
            @change="value => handleChange('area', value)"
          ></ny-region-picker>
        </el-form-item>

        <template v-if="isApp">
          <ny-form-item-radio
            required
            v-if="isHobbies || isGames || isPeople || isAppInterest"
            label="人群定向"
            prop="crowdOrient"
            v-model="plan.crowdOrient"
            :data="planManage.crowdOrients"
            @change="value => handleChange('crowdOrient', value)"
          >
            <div v-show="plan.crowdOrient === '1'" class="ny-crowd">
              <div class="ny-crowd__group" v-if="isPeople">
                <h3>人口属性</h3>
                <div class="ny-crowd__list">
                  <div class="ny-crowd__item">
                    <span class="ny-crowd__type">年龄</span>
                    <ny-form-item-checkbox
                      multiple
                      v-model="plan.age"
                      :data="planManage.ages"
                      @change="value => handleChange('age', value)"
                    ></ny-form-item-checkbox>
                  </div>
                  <div class="ny-crowd__item">
                    <span class="ny-crowd__type">性别</span>
                    <ny-form-item-checkbox
                      multiple
                      v-model="plan.sex"
                      :data="planManage.sexes"
                      @change="value => handleChange('sex', value)"
                    ></ny-form-item-checkbox>
                  </div>
                  <div class="ny-crowd__item">
                    <span class="ny-crowd__type">收入信息</span>
                    <ny-form-item-checkbox
                      multiple
                      v-model="plan.income"
                      :data="planManage.incomes"
                      @change="value => handleChange('income', value)"
                    ></ny-form-item-checkbox>
                  </div>
                  <!-- <div class="ny-crowd__item">
                <span class="ny-crowd__type">关键人生阶段</span>
                <ny-form-item-checkbox
                  multiple
                  v-model="plan.stage"
                  :data="data.stages"
                  @change="(value) => handleChange('stage', value)"
                ></ny-form-item-checkbox>
              </div>
              <div class="ny-crowd__item">
                <span class="ny-crowd__type">学历信息</span>
                <ny-form-item-checkbox
                  multiple
                  v-model="plan.education"
                  :data="data.educations"
                  @change="(value) => handleChange('education', value)"
                ></ny-form-item-checkbox>
              </div>
              <div class="ny-crowd__item">
                <span class="ny-crowd__type">职业信息</span>
                <ny-form-item-checkbox
                  multiple
                  v-model="plan.career"
                  :data="data.careers"
                  @change="(value) => handleChange('career', value)"
                ></ny-form-item-checkbox>
                  </div>-->
                </div>
              </div>
              <!-- <div class="ny-crowd__group">
                <h3>经济状况</h3>
                <div class="ny-crowd__list">
                  <div class="ny-crowd__item">
                    <span class="ny-crowd__type">收入信息</span>
                    <ny-form-item-checkbox
                      multiple
                      v-model="plan.income"
                      :data="planManage.incomes"
                      @change="(value) => handleChange('income', value)"
                    ></ny-form-item-checkbox>
                  </div>
                  <div class="ny-crowd__item">
                    <span class="ny-crowd__type">是否有房</span>
                    <ny-form-item-checkbox
                      multiple
                      v-model="plan.house"
                      :data="planManage.houses"
                      @change="(value) => handleChange('house', value)"
                    ></ny-form-item-checkbox>
                  </div>
                  <div class="ny-crowd__item">
                    <span class="ny-crowd__type">是否有车</span>
                    <ny-form-item-checkbox
                      multiple
                      v-model="plan.car"
                      :data="planManage.cars"
                      @change="(value) => handleChange('car', value)"
                    ></ny-form-item-checkbox>
                  </div>
                </div>
              </div>-->
              <div class="ny-crowd__group" v-if="isHobbies || isGames">
                <h3>兴趣偏好</h3>
                <div class="ny-crowd__list">
                  <!--  && isYWN && isAndroid -->
                  <div class="ny-crowd__item" v-if="isHobbies">
                    <span class="ny-crowd__type">基础兴趣</span>
                    <ny-form-item-checkbox
                      multiple
                      v-model="plan.hobby"
                      :data="planManage.hobbies"
                      @change="value => handleChange('hobby', value)"
                    ></ny-form-item-checkbox>
                  </div>
                  <div class="ny-crowd__item" v-if="isGames">
                    <span class="ny-crowd__type">游戏分类</span>
                    <ny-form-item-checkbox
                      @change="value => handleChange('game', value)"
                      multiple
                      v-model="plan.game"
                      :data="planManage.games"
                    ></ny-form-item-checkbox>
                  </div>
                </div>
              </div>
              <div class="ny-crowd__group" v-if="isAppInterest">
                <!-- 只在安卓展示 -->
                <h3>应用兴趣</h3>
                <ny-form-item-checkbox
                  multiple
                  v-model="plan.app_interest"
                  :data="planManage.appInterests"
                ></ny-form-item-checkbox>
              </div>
            </div>
          </ny-form-item-radio>
          <ny-form-item-radio
            v-if="isDevice"
            required
            label="设备定向"
            prop="deviceOrient"
            v-model="plan.deviceOrient"
            :data="planManage.deviceOrients"
            @change="value => handleChange('deviceOrient', value)"
          >
            <el-transfer
              v-show="plan.deviceOrient === '1'"
              class="ny-device"
              filterable
              :filter-method="filterMethod"
              :titles="['选择设备', '已选设备']"
              filter-placeholder="请输入搜索内容"
              v-model="plan.devices"
              :props="{
                key: 'value',
                label: 'name'
              }"
              :data="
                isAndroid ? planManage.androidDevices : planManage.iosDevices
              "
              @change="value => handleChange('devices', value)"
            ></el-transfer>
          </ny-form-item-radio>
        </template>
        <ny-form-item-radio
          v-if="isBlackName"
          required
          label="黑白名单"
          prop="bwList"
          v-model="plan.bwList"
          :data="planManage.bwLists"
          @change="value => handleChange('bwList', value)"
        >
          <div v-if="plan.bwList === '1' || plan.bwList === '0'" class="ad-plan-edit__bw">
            <div class="ad-plan-edit__upload-bw">
              <ny-upload
                class="ad-plan-edit__upload"
                style="margin-left: 12%"
                v-model="fileList"
                :show-file-list="false"
                btn-text="上传黑白名单"
                btn-type="success"
                size="small"
                @on-change="handleUploadBwList"
              ></ny-upload>
              <a class="ad-plan-edit__upload-temp" :href="tempUrl">下载模板</a>
              <span class="ad-plan-edit__upload-url">{{ plan.bwUrl }}</span>
            </div>
            <span
              class="ad-plan-edit__upload-tip"
            >上传的文件格式为txt文件，文件大小不得超过50M，每行只写一个任意类型的设备号或ip，系统自动判断类型。</span>
          </div>
        </ny-form-item-radio>
        <up-form-item-radio
          v-if="isShowNGAOrigen"
          label="NGA板块定向"
          required
          v-model="plan.ngaOrient"
          :data="planManage.ngaOptions"
        >
        </up-form-item-radio>
        <up-form-item v-if="isShowNGAOrigen">
          <div class="ad-plan-edit__nga" v-if="plan.ngaOrient">
            <tree-transfer
            :title="ngaTitle"
            :from_data="planManage.ngaOrients"
            :to_data="planManage.toData"
            node_key="id"
            modol="transfer"
            pid="pid"
            :rootPidValue="0"
            ref="ngaOrient"
            :filter="true"
            @add-btn="handleNgaAdd"
            @remove-btn ="handleNgaRemove"
            :defaultCheckedKeys="plan.nga_section_ids"
            :defaultTransfer="true"
            ></tree-transfer>
          </div>
        </up-form-item>
        <h4 class="form-title">预算及时间</h4>
        <el-form-item
          required
          label="投放时间"
          :prop="putTimeType === 0 ? 'putCycle' : 'is_long_time'"
          :show-message="
            isEmptyObject(plan.putCycle) ||
              (plan.putCycle &&
                plan.putCycle.time &&
                !plan.putCycle.time.length)
          "
        >
          <up-radio-group
            component="el-radio-button"
            size="small"
            v-model="putTimeType"
            :data="putTimeTypeOptions"
            @up:radio-group:change="handlePutTimeType"
          ></up-radio-group>
          <dateRange2
            v-if="putTimeType === 0"
            ref="date"
            class="ad-plan-edit__date-range ml16 mt20"
            page-info="advertise"
            :type24="false"
            :disabledType="true"
            :disabledTime="disabledTime"
            :default-date="defaultDate"
            :receive-data="receiveData"
            :dateDisable="dateDisable"
            :receive-date-range="receiveDateRange"
            @selectedCycle="handleDataRangeChange"
          ></dateRange2>
          <span
            v-if="(isEdit || true) && !this.specialIds && putTimeType === 0"
            style="position: absolute; left: 280px; top: 0; margin-left: 6px;"
            :style="
              plan.putCycle.time.length > 60
                ? 'color: #F56C6C'
                : 'color: #909399'
            "
          >选择排期总天数最多只支持60天</span>
        </el-form-item>
        <ny-form-item-input
          size="small"
          label="日预算"
          required
          prop="budget"
          v-model="plan.budget"
          @input.native="changeComdify('plan', 'budget')"
        ></ny-form-item-input>
        <ny-form-item-input
          required
          label="出价"
          prop="bid"
          type="age"
          v-model="plan.bid"
          @input="changeCode('bid')"
        >
          <template slot="append" >
            <template v-if="isShowSuggestPrice">
              最低出价:（{{ suggestPrice }}）元
            </template>
            </template>
        </ny-form-item-input>
        <el-form-item label="曝光频次" class="labelAfter i-question-box">
          <el-tooltip class="item" effect="light" placement="right">
            <div slot="content">每人每天曝光控制</div>
            <i class="icon iconfont icon-iconfontquestion"></i>
          </el-tooltip>
          <el-input
            v-model="plan.cpmNum"
            type="age"
            placeholder="请输入曝光频次"
            @input="changeCode('cpmNum')"
          ></el-input>
        </el-form-item>
        <el-form-item label="点击频次" class="i-question-box">
          <el-tooltip class="item" effect="light" placement="right">
            <div slot="content">每人每天点击控制</div>
            <i class="icon iconfont icon-iconfontquestion"></i>
          </el-tooltip>
          <el-input
            v-model="plan.clickNum"
            type="age"
            placeholder="请输入点击频次"
            @input="changeCode('clickNum')"
          ></el-input>
        </el-form-item>
        <ny-form-item-radio
          required
          label="投放控制/时"
          prop="hourPutControl"
          v-model="plan.hourPutControl"
          :data="planManage.hourPutControls"
          @change="value => handleChange('hourPutControl', value)"
        ></ny-form-item-radio>
        <ny-form-item-radio
          required
          label="轮播规则"
          prop="carouselRule"
          v-model="plan.carouselRule"
          :data="planManage.carouselRules"
          @change="value => handleChange('carouselRule', value)"
        ></ny-form-item-radio>
        <el-form-item>
          <el-button
            v-if="!isShow"
            size="large"
            type="primary"
            @click="submitForm('plan')"
            :disabled="committing"
          >{{ !next ? btnText("保存") : "保存" }}</el-button>
          <el-button
            v-if="!isShow"
            size="large"
            type="primary"
            @click="submitForm('plan', true)"
            :disabled="committing"
          >
            {{
            next ? btnText("保存并新建创意") : "保存并新建创意"
            }}
          </el-button>
          <el-button size="large" class="is-cancel" @click="cancel">
            {{
            isShow ? "返回" : "取消"
            }}
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import treeTransfer from 'el-tree-transfer'
import {
  headPanel,
  NySelect,
  NyRegionPicker,
  NyFormItemInput,
  NyFormItemRadio,
  NyFormItemCheckbox,
  dateRange2,
  NyUpload
} from '@/global/components';
// import { post, put } from '@/manager/http/index'
import { BASE_URL } from '@/global/util/constants';
import {
  tip,
  isEmptyObject,
  availableDate,
  comdify,
  delcommafy
} from '@/global/util/util';
const BW_TYPES = ['text/plain'];
export default {
  computed: {
    ...mapGetters({
      planManage: 'plan/planManage',
      userid: 'login/userid',
      user: 'login/user'
    }),
    ...mapState('transferEvent', ['transferEventSelect']),
    tempUrl() {
      return `${BASE_URL}/${this.platform}/ads/ad/blackwhite`;
    },
    btnText() {
      return function (text) {
        return this.committing ? `${text}中...` : text;
      };
    },
    isShowSuggestPrice() {
      return ['cpm', 'cpc'].includes(this.plan.payment)
    },
    isShowTransformation() {
      return ['ocpm', 'ocpc'].includes(this.plan.payment)
    }
  },
  data() {
    let validateOrderName = (rule, value, callback) => {
      let self = this;
      if (value === '') {
        callback(new Error('请输入计划名称'));
      } else if (value.length > 50) {
        callback(new Error('输入内容不得超过50个字符'));
      } else {
        this.isRepeatOrderName().then(res => {
          if (res && (value !== self.plan.editOrderName || self.isCopy)) {
            callback(new Error('计划名称已存在，请重新输入'));
          }
          callback();
        });
      }
    };
    let validateBudget = (rule, value, callback) => {
      let reg = /^[0-9]*$/;
      if (value === '') {
        callback(new Error('请输入日预算'));
      } else if (!reg.test(delcommafy(value))) {
        callback(new Error('请输入数字'));
      } else {
        if (delcommafy(value) < 300) {
          callback(new Error('日预算最低300元'));
        } else if (delcommafy(value) > 10000000) {
          callback(new Error('日预算不得超过10000000'));
        }
        callback();
      }
    };
    let validateBid = (rule, value, callback) => {
      if (value < this.suggestPrice && this.isShowSuggestPrice) {
        callback(new Error('出价低于最低出价'));
      } else if (
        (value <= 0.1 && value > 10000) ||
        !(value > 0.1 && value <= 10000 && /^\d*(\.\d{1,2})?$/.test(value))
      ) {
        callback(new Error('出价不低于0.1, 不超过10000元, 最多两位小数'));
      } else {
        callback();
      }
    };
    return {
      loading: false,
      isAdd: true,
      isEdit: false,
      isEditFirst: false,
      isShow: false,
      isCopy: false,
      isShowNGAOrigen: false, // 是否展示nga板块定向
      committing: false,
      platform: '',
      isXiaomi: false,
      isNotOnlyXiaomi: false,
      isNGA: false,
      isNotOnlyNGA: false,
      isYNA: false,
      isPeople: false,
      isHobbies: false,
      isAppInterest: false,
      isGames: false,
      isDevice: false,
      isBlackName: false,
      isAndroid: false,
      isApp: false,
      next: false,
      specialIds: false,
      putTimeType: 1,
      putTimeTypeOptions: [
        { name: '从今日起长期投放', value: 1 },
        { name: '指定日期时间范围', value: 0 }
      ],
      dateDisable(time) {
        return new Date(time).getTime() < new Date().getTime() - 8.64e7;
      },
      formatedValue: {
        place: {},
        area: {},
        nga: {}
      },
      placeTitle: {
        parent: '媒体',
        children: '广告位'
      },
      ngaTitle: ['选择定向', '已选定向'],
      suggestPrice: 0,
      defaultDate: [],
      receiveData: [],
      receiveDate: [],
      disabledTime: {},
      receiveDateRange: [],
      filterMethod(query, item) {
        return item.name.indexOf(query) > -1;
      },
      fileList: [],
      plan: {
        advertiser: '', // 广告主
        groupAdver: '', // 广告组
        name: '', // 计划名称
        transformation_target: '',
        editOrderName: '',
        flowType: undefined, // 流量类型
        portType: '', // 投放终端
        placeAttr: '', // 广告位属性
        infoStyle: '', // 信息流展示样式
        place: [], // 广告位
        realPlace: [], // 广告位
        area: [], // 地域
        realArea: {}, // 上传地域
        crowdOrient: [], // 人群定向
        devices: [], // 设备定向
        deviceOrient: [], // 是否设备定向
        iosDevices: [], // iOS 设备
        androidDevices: [], // android 设备
        is_long_time: 1,
        age: [], // 年龄
        sex: [], // 性别
        game: [], // 游戏
        hobby: [], // 兴趣偏好
        app_interest: [], // 应用兴趣
        stage: [], /// 关键人生阶段
        education: [], // 学历信息
        career: [], // 职业信息
        income: [], // 收入信息
        house: [], // 是否有房
        car: [], // 是否有车
        networkWay: [], // 联网方式
        operator: [], // 运营商
        ngaOrientChecked: [], // nga 板块定向
        putCycle: { time: [], date: [] },
        ngaOrient: 0, // 是否nga板块定向
        nga_section_ids: [], // nga板块定向id
        add_nga_section_ids: [], // 添加定向id
        budget: '', // 预算及时间
        payment: '', // 结算方式
        cpmNum: '', // 曝光频次
        clickNum: '', // 点击频次
        bid: '', // 出价
        hourPutControl: '', // 小时控制
        carouselRule: '', // 轮播规则
        bwList: '', // 是否黑白名单
        bwUrl: '' // 黑白名单地址
      },
      rules: {
        advertiser: [
          { required: true, message: '请选择广告主', trigger: 'change' }
        ],
        groupAdver: [
          { required: true, message: '请选择广告组', trigger: 'change' }
        ],
        name: [
          { required: true, validator: validateOrderName, trigger: 'blur' }
        ],
        flowType: [
          { required: true, message: '请选择流量类型', trigger: 'change' }
        ],
        transformation_target: [
          { required: true, message: '请选择转化目标', trigger: 'change' }
        ],
        portType: [
          { required: true, message: '请选择投放终端', trigger: 'change' }
        ],
        placeAttr: [
          { required: true, message: '请选择广告位属性', trigger: 'change' }
        ],
        infoStyle: [
          { required: true, message: '请选择信息流展示样式', trigger: 'change' }
        ],
        place: [{ required: true, message: '请选择广告位', trigger: 'change' }],
        area: [
          { required: true, message: '请选择投放地域', trigger: 'change' }
        ],
        budget: [{ require: true, trigger: 'blur', validator: validateBudget }],
        bid: [{ validator: validateBid, trigger: 'blur' }],
        hourPutControl: [
          { required: true, message: '请选择时投放控制', trigger: 'change' }
        ],
        carouselRule: [
          { required: true, message: '请选择轮播规则', trigger: 'change' }
        ],
        payment: [
          { required: true, message: '请选择结算方式', trigger: 'change' }
        ],
        deviceOrient: [
          { required: true, message: '请选择设备定向', trigger: 'change' }
        ],
        crowdOrient: [
          { required: true, message: '请选择人群定向', trigger: 'change' }
        ],
        bwList: [
          { required: true, message: '请选择黑白名单', trigger: 'change' }
        ],
        is_long_time: [{ required: true, message: '请选择投放策略', trigger: 'change' }]
      },
      isEmptyObject
    };
  },
  watch: {
    'user'() {
      let ids = VUE_APP_ENV === 'online' ? [10249] : [925]
      if ((ids.indexOf(this.user.id) > -1 && this.platform === 'agency') || (this.platform === 'ad-user' && ids.indexOf(this.user.parent_id) > -1)) {
        this.specialIds = true
        this.dateDisable = function (time) {
          return new Date(time).getTime() < new Date('2019-09-01').getTime() - 8.64e7;
        };
      }
    }
  },
  async created() {
    this.loading = true;
    this.platform = this.$router.currentRoute.meta.platform;
    this.isAdd = !this.$route.params.id;
    this.isShow = this.$route.name === 'plan/view';
    this.isCopy = this.$route.name === 'plan/copy';
    let ids = VUE_APP_ENV === 'online' ? [10249] : [925]
    if ((ids.indexOf(this.user.id) > -1 && this.platform === 'agency') || (this.platform === 'ad-user' && ids.indexOf(this.user.parent_id) > -1)) {
      this.specialIds = true
      this.dateDisable = function (time) {
        return new Date(time).getTime() < new Date('2019-09-01').getTime() - 8.64e7;
      };
    }
    await this.init();
    this.loading = false;
  },
  methods: {
    ...mapActions('plan/', ['getNgaOrient']),
    ...mapActions('transferEvent', ['getTransferEventSelect']),
    async init() {
      if (this.platform === 'agency') {
        await this.$store.dispatch('plan/advertiserList', {
          platform: this.platform
        }); // 获取广告主列表
      } else {
        this.changeSelect({ type: 'advertiser' });
      }
      await this.$store.dispatch('plan/getAreaMenu');
      await this.$store.dispatch('plan/getCommonItem');
      if (this.$route.params.id) {
        await this.getPlanDetails();
      } else {
        this.plan.hourPutControl =
          this.planManage.hourPutControls.length > 0
            ? this.planManage.hourPutControls[1].value
            : '';
      }
      this.getTransferEventSelect()
    },
    dataFilter(date) {
      let arr = [];
      date.forEach(time => {
        let temp = [];
        time.time.forEach(t => {
          if (t.length === 1) {
            temp.push(
              t < 10
                ? ['0' + t, '0' + (parseInt(t) + 1)]
                : [t + '', parseInt(t) + 1 + '']
            );
          } else {
            temp.push(
              t.map((v, i) => {
                if (i === 1) {
                  v = parseInt(v) + 1;
                }
                return v < 10 ? '0' + parseInt(v) : v + '';
              })
            );
          }
        });
        arr.push({
          date: time.date,
          time: temp
        });
      });
      return arr;
    },
    async changeSelect({ value, type }) {
      if (type === 'advertiser') {
        await this.$store.dispatch('plan/groupAdverSelect', {
          platform: this.platform,
          data: {
            adverId: this.platform === 'agency' ? this.plan.advertiser : ''
          }
        });
        // await this.changeSelect({ type: 'groupAdver' })
        if (!this.isEditFirst) {
          this.plan.groupAdver = '';
          this.plan.portType = '';
          this.plan.flowType = '';
          this.plan.place = [];
          this.plan.placeAttr = '';
          this.plan.infoStyle = '';
          this.plan.payment = '';
        }
      } else if (type === 'groupAdver') {
        await this.getPayments();
        await this.$store.dispatch('plan/getCommonPlace', {
          params: 'flow_type',
          data: {
            platform: this.platform,
            order_id: this.plan.groupAdver
          },
          api: 'PLAN_FLOW_TYPE_MENU'
        });
        if (!this.isEditFirst) {
          this.plan.flowType = this.planManage.curFlowType;
          this.plan.payment = this.planManage.curPayment;
        }
        await this.flowTypeChange();
      }
      /* if (type === 'channel' || type === 'channelType') {
        if (type === 'channelType') {
          this.getChannelMenu(this.plan.channelType)
        } else {
          this.getPositionMenu()
        }
      } else if (type === 'advertiser') {
        this.getMediaMenu()
      } */
    },
    async flowTypeChange(value) {
      this.isApp = this.plan.flowType === '1';
      await this.getPortTypeMenu();
    },
    async getPortTypeMenu({ flowType } = {}) {
      await this.$store.dispatch('plan/getCommonPlace', {
        params: 'port_type',
        data: {
          platform: this.platform,
          flow_type: flowType || this.plan.flowType,
          order_id: this.plan.groupAdver
        },
        api: 'PLAN_PORT_TYPE_MENU'
      });
      if (!this.isEditFirst) {
        this.plan.portType = this.planManage.curPortType;
      }
      await this.portTypeChange();
    },
    async portTypeChange(value) {
      this.isAndroid = this.plan.portType !== '1';
      await this.getPlaceAttr();
    },
    async getPlaceAttr({ flowType } = {}) {
      await this.$store.dispatch('plan/getCommonPlace', {
        params: 'place_attribute',
        data: {
          platform: this.platform,
          flow_type: flowType || this.plan.flowType,
          order_id: this.plan.groupAdver,
          port_type: this.plan.portType,
          payment: this.plan.payment
        },
        api: 'PLAN_PLACE_ATTRIBUTE_MENU'
      });
      if (!this.isEditFirst) {
        this.plan.placeAttr = this.planManage.curPlaceAttr;
      }
      await this.placeAttrChange();
    },
    async placeAttrChange(value) {
      await this.getMediaPlace();
    },
    async changeInfoStyle(value) {
      await this.getMediaPlace();
    },
    async getPayments() {
      /* let placeStr = ''
      Object.keys(this.plan.realPlace).forEach(item => {
        placeStr += this.plan.realPlace[item].join(',') + ','
      })
      if (!placeStr) {
        return false
      } */
      await this.$store.dispatch('plan/getCommonPlace', {
        params: 'payment',
        data: {
          platform: this.platform,
          order_id: this.plan.groupAdver
        },
        api: 'PLAN_PAYMENT_MENU'
      });
      if (!this.isEditFirst) {
        this.plan.payment = '';
      } else {
        await this.getPlaceAttr();
        // await this.getMediaPlace()
      }
      // await this.getMediaPlace()
    },
    async getMediaPlace({ flowType } = {}) {
      await this.$store.dispatch('plan/getCommonPlace', {
        params: 'places',
        data: {
          platform: this.platform,
          flow_type: flowType || this.plan.flowType,
          order_id: this.plan.groupAdver,
          port_type: this.plan.portType,
          information: this.plan.placeAttr === '2' ? this.plan.infoStyle : '',
          place_attribute: this.plan.placeAttr,
          payment: this.plan.payment
        },
        api: 'PLAN_PLACES_MENU'
      });
      if (!this.isEditFirst) {
        this.plan.place = [];
        this.plan.realPlace = {};
      }
      await this.getSuggestPrice();
    },
    async getSuggestPrice() {
      let placeStr = '';
      Object.keys(this.plan.realPlace).forEach(item => {
        placeStr += this.plan.realPlace[item].join(',') + ',';
      });
      if (!placeStr || !this.plan.payment) {
        return false;
      }
      await this.$store
        .dispatch('plan/getSuggestPrice', {
          platform: this.platform,
          data: {
            place_ids: placeStr,
            payment: this.plan.payment
          }
        })
        .then(result => {
          this.suggestPrice = result.data;
        });
    },
    changeComdify(form, name) {
      this.$nextTick(() => {
        if (this[form][name] !== null) {
          this[form][name] = comdify(delcommafy(this[form][name]), 'parseFloat');
        }
      });
    },
    changeCode(name) {
      this.$nextTick(() => {
        if (this.plan[name] !== null) {
          this.plan[name] = this.plan[name].replace(/[^\d*.]/g, '');
        }
      });
    },
    handlePutTimeType(value) {
      this.plan.is_long_time = this.putTimeType
      this.$refs.plan.clearValidate('putCycle')
      this.$refs.plan.clearValidate('is_long_time')
    },
    handleDataRangeChange({ date, dateCycle }) {
      dateCycle = availableDate(dateCycle);
      // this.receiveDate = date;
      if (!this.isEditFirst) {
        this.receiveData = this.dataFilter(date);
        this.receiveDateRange = [...dateCycle];
        this.plan.putCycle = { time: date, date: [...dateCycle] };
        if (this.plan.putCycle.time.length > 60 && !this.specialIds) {
          return tip('投放周期超过60天，请重新修改后再提交');
        }
      }
    },
    async handleChange(type, value) {
      if (type === 'area') {
        // 新地域组件
        this.plan.area = value.original;
        this.plan.realArea = value.formated;
      } else if (type === 'place') {
        if (!this.plan.placeAttr) return false;
        this.setMediaShow(value.formated, value.original);
        this.plan.place = value.original;
        this.plan.realPlace = value.formated;
        this._getNgaOrient(this.plan.place)
        /* if (!this.isEditFirst) {
          await this.getSuggestPrice()
        } */
        await this.getSuggestPrice();
      } else if (type === 'payment') {
        if (!this.isEditFirst) {
          await this.getPlaceAttr();
        }
      } else if (type === 'nga_section_ids') {
        this._ngaOrient()
      } else {
        this.plan[type] = value;
      }
      if (type === 'crowdOrient' && value === '2') {
        this.plan.sex = [];
        this.plan.age = [];
        this.plan.hobby = [];
        this.plan.app_interest = []
        this.plan.game = [];
      }
    },
    async _getNgaOrient(place) {
      // eslint-disable-next-line no-unused-vars
      let placeStr = '';
      Object.keys(this.plan.realPlace).forEach(item => {
        placeStr += this.plan.realPlace[item].join(',') + ',';
      });
      const result = await this.getNgaOrient({ data: { place_ids: placeStr } })
      if (!this.isEditFirst) {
        this.planManage.ngaOrients = result.data
        this.isShowNGAOrigen = result.data.length > 0
        this.planManage.toData = []
      }
    },
    handleNgaAdd(fromData, toData, obj) {
      this.plan.add_nga_section_ids = this.getNgaOrientId(toData)
    },
    handleNgaRemove(fromData, toData, obj) {
      this.plan.add_nga_section_ids = this.getNgaOrientId(toData)
    },
    getNgaOrientId(toData) {
      return toData.reduce((prev, cur) => {
        if (cur.children && cur.children.length < 1) {
          prev.push({
            id: cur.id,
            children: []
          })
        } else {
          prev.push({
            id: cur.id,
            children: [...this.getNgaOrientId(cur.children)]
          })
        }
        return prev
      }, [])
    },
    setMediaShow(data, origin) {
      // let medias = Object.keys(data)
      let medias = origin.reduce((acc, key) => {
        key.children.forEach(item => {
          if (acc.indexOf(item.pMedia) < 0) {
            acc.push(item.pMedia);
          }
        });
        return acc;
      }, []);
      /**
       * 1引力,2NGA,3A9VG,11英威诺,新义71,掌阅ADX106,94小米ADX
       */
      this.isPeople = !['3', '94', '106', '71'].some(
        item => medias.indexOf(item) > -1
      );
      this.isHobbies = !['3', '94', '106', '71'].some(
        item => medias.indexOf(item) > -1
      );
      this.isAppInterest = this.plan.portType === '2'
      this.isGames = medias.length === 1 && medias[0] === '2';
      this.isDevice = true;
      this.isBlackName = !['94'].some(item => medias.indexOf(item) > -1);
      /* this.isYNA = ['1', '2', '3'].some(item => medias.indexOf(item) > -1)
      this.isYWN = ['11'].some(item => medias.indexOf(item) > -1)
      if (medias.length === 1 && medias[0] === '2') {
        this.isNGA = true
        this.isNotOnlyNGA = false
      } else if (medias.indexOf('2') > -1) {
        this.isNotOnlyNGA = true
        this.isNGA = false
      } else {
        this.isNGA = false
        this.isNotOnlyNGA = false
      }
      if (medias.length === 1 && medias[0] === '94') {
        this.isXiaomi = true
        this.isNotOnlyXiaomi = false
        // 小米不支持 黑名单-IDFA
        this.planManage.bwItems = this.planManage.bwItems.filter(v => ['3', '6'].indexOf(v.value) === -1)
      } else if (medias.indexOf('94') > -1) {
        this.isXiaomi = false
        this.isNotOnlyXiaomi = true
      } else {
        this.isXiaomi = false
        this.isNotOnlyXiaomi = false
      } */
    },
    async handleUploadBwList(file, fileList) {
      const isSupport = BW_TYPES.indexOf(file.raw.type) > -1;
      const isLt50M = file.raw.size / 1024 / 1024 < 50;
      if (!isSupport) {
        return tip('黑白名单文件格式不正确！');
      }

      if (!isLt50M) {
        return tip('黑白名单文件大小不能超过 50M！');
      }

      const res = await this.$store.dispatch('plan/uploadBwList', {
        platform: this.platform,
        file: file.raw
      });
      if (res.code !== 1) this.$message.error(res.msg || '黑白名单上传失败！')
      else {
        tip('上传黑白名单成功！', { type: 'success' });
        this.handleChange('bwUrl', res.data);
      }
    },
    /* handlePutCycleSelect ({ date, dateCycle, formatDate }) {
      this.putCycleData = dateCycle
      this.plan.putCycle = { time: date, formatDate, date: dateCycle }
    }, */
    async isRepeatOrderName() {
      // 判断计划是否重名
      let flag = false;
      if (this.plan.name !== '') {
        await this.$store
          .dispatch('plan/planNameIsRepeat', {
            platform: this.platform,
            data: { ad_name: this.plan.name }
          })
          .then(data => {
            if (data && data.code === 1 && data.data.status === 1) {
              flag = true;
            } else {
              flag = false;
            }
          });
      }
      return flag;
    },
    async getPlanDetails() {
      this.isEditFirst = true;
      await this.$store
        .dispatch('plan/detailsAds', {
          platform: this.platform,
          data: {
            ad: this.$route.params.id
          }
        })
        .then(async res => {
          if (res.code === 1) {
            let data = res.data;
            this.plan.name = data.ad_name;
            this.plan.editOrderName = data.ad_name;
            this.plan.advertiser = data.advertiser_id;
            this.plan.flowType = data.flow_type;
            this.plan.portType = data.port_type;
            this.plan.placeAttr = data.place_attribute;
            this.plan.infoStyle = data.information;
            this.plan.groupAdver = data.order_id;
            this.plan.payment = data.payment;
            this.plan.transformation_target = data.transformation_target
            // await this.getPayments()
            await this.changeSelect({ type: 'advertiser' });
            await this.changeSelect({ type: 'groupAdver' });
            this.plan.place = await this.$refs.place.getSelectedData(
              this.planManage.placeMenu,
              data.media_place
            );
            this.setMediaShow(data.media_place, this.plan.place);
            this.plan.realPlace = data.media_place;
            this.plan.bid = data.bidding;
            this.plan.budget = comdify(data.budget, 'parseFloat');
            this.plan.clickNum = data.click_num;
            this.plan.cpmNum = data.cpm_num;
            this.plan.hourPutControl = data.plan_hour_type;
            this.plan.carouselRule = data.m_play;
            this.plan.bwList = data.is_black_white;
            // 广告位
            this.plan.realPlace = data.media_place;
            // this.formatedValue.place = data.media_place
            // this.plan.realArea = data.cities
            // 地域
            this.plan.area = this.$refs.area.getSelectedData(
              this.planManage.areaMenu,
              data.cities
            );
            this.plan.realArea = data.cities;
            // this.formatedValue.area = data.cities
            // 设备定向赋值
            this.plan.deviceOrient = data.media_ids.length ? '1' : '2';
            this.plan.devices = data.media_ids;
            // 黑名单赋值
            if (data.black_white) {
              const bw = JSON.parse(data.black_white);
              // this.plan.bwItem = Object.keys(bw)[0];
              this.plan.bwUrl = Object.values(bw)[0];
            }
            // 人群定向赋值
            this.plan.crowdOrient = data.is_oriented;

            this.plan.sex = data.orienteds ? data.orienteds.sex : [];
            this.plan.age = data.orienteds ? data.orienteds.age : [];
            this.plan.app_interest = data.orienteds ? data.orienteds.app_interest : []
            if (this.isHobbies) {
              this.plan.hobby = data.orienteds ? data.orienteds.hobby : [];
            }
            if (this.isGames) {
              this.plan.game = data.orienteds ? data.orienteds.game_type : [];
            }
            this.plan.stage = data.orienteds ? data.orienteds.stages_life : [];
            this.plan.education = data.orienteds
              ? data.orienteds.education
              : [];
            this.plan.career = data.orienteds ? data.orienteds.career : [];
            this.plan.income = data.orienteds ? data.orienteds.income : [];
            this.plan.house = data.orienteds ? data.orienteds.house : [];
            this.plan.car = data.orienteds ? data.orienteds.car : [];
            this.plan.networkWay = data.network_way;
            this.plan.operator = data.operator;
            this.plan.nga_section_ids = data.nga_section_ids;
            this.plan.ngaOrient = data.nga_section_ids.length > 0 ? 1 : 0
            // 时间
            this.receiveDate = data.time;
            this.receiveData = this.dataFilter(data.time);
            /* let dateTime = new Date().getTime() > new Date(availableDate(data.date)[0][0]).getTime() ? formatDate(new Date(), 'YYYY-MM-DD') : availableDate(data.date)[0][0]
          this.defaultDate = filterDefaultDate(dateTime, 3) */
            // this.defaultDate = this.receiveData
            this.receiveDateRange = availableDate(data.date);
            this.plan.putCycle = {
              time: data.time,
              date: availableDate(data.date)
            };
            this.plan.is_long_time = this.putTimeType = parseInt(data.is_long_time)
          }
        });
      this.isEditFirst = false;
      this.$nextTick(_ => {
        setTimeout(() => {
          if (this.$refs.ngaOrient) {
            this.$refs.ngaOrient.addToAims(true)
          }
        }, 1000)
      })
    },
    getSubmitParams() {
      const {
        deviceOrient,
        devices,
        crowdOrient,
        hobby,
        // eslint-disable-next-line camelcase
        app_interest,
        sex,
        age,
        income,
        game,
        // stage, education, career, , house, car,
        bwList,
        bwUrl
      } = this.plan;
      if ((!this.plan.putCycle.date.length || !this.plan.putCycle.time.length) && this.plan.is_long_time === 0) {
        this.committing = false;
        return tip('请选择投放周期！');
      }
      if (this.plan.putCycle.time.length > 60 && !this.specialIds) {
        this.committing = false;
        return tip('投放周期超过60天，请重新修改后再提交');
      }
      // if (this.plan.putCycle.date)
      if (this.isDevice && this.plan.deviceOrient === '1' && !devices.length) {
        this.committing = false;
        return tip('请选择至少选择一个设备！');
      }
      if (
        crowdOrient === '1' &&
        (this.isPeople || this.isGames || this.isHobbies || this.isAppInterest)
      ) {
        // if (this.isYWN && this.isAndroid && !hobby.length) {
        //   this.committing = false
        //   return tip('人群定向中兴趣偏好至少选择一个！')
        // }

        if (this.isHobbies && !hobby.length) {
          this.committing = false;
          return tip('人群定向中基础兴趣偏好至少选择一个！');
        }
        if (this.isGames && !game.length) {
          this.committing = false;
          return tip('人群定向中游戏分类偏好至少选择一个！');
        }
        if (this.isAppInterest && !app_interest.length) {
          this.committing = false;
          return tip('人群定向应用兴趣偏好至少选择一个！');
        }

        // const crowdFields = [sex, age, hobby, stage, education, career, income, house, car]
        const crowdFields = [sex, age, income];
        if (this.isPeople && !crowdFields.every(item => item.length > 0)) {
          this.committing = false;
          return tip('人群定向中人口属性、经济状况每项至少选择一个！');
        }
      }

      if (this.isBlackName && bwList !== '2' && !bwUrl) {
        this.committing = false;
        return tip('请上传一份黑白名单！');
      }
      let formData = {
        advertise_id: this.plan.advertiser,
        order_id: this.plan.groupAdver,
        ad_name: this.plan.name,
        flow_type: this.plan.flowType,
        port_type: this.plan.portType,
        place_attribute: this.plan.placeAttr,
        media_place: this.plan.realPlace,
        cities: this.plan.realArea,
        time: this.putTimeType === 0 ? this.plan.putCycle.time : [],
        date: this.putTimeType === 0 ? this.plan.putCycle.date : [],
        bidding: this.plan.bid,
        is_long_time: this.plan.is_long_time,
        budget: delcommafy(this.plan.budget),
        payment: this.plan.payment,
        transformation_target: this.plan.transformation_target,
        click_num: this.plan.clickNum,
        cpm_num: this.plan.cpmNum,
        plan_hour_type: this.plan.hourPutControl,
        m_play: this.plan.carouselRule,
        is_black_white: this.plan.bwList,
        nga_section_ids: this.plan.ngaOrient ? this.plan.add_nga_section_ids : [],
        information: this.plan.placeAttr === '2' ? this.plan.infoStyle : 0
      };
      if (this.isBlackName) {
        if (this.plan.bwList !== '2') {
          formData.black_white = {
            [this.plan.bwList === '1' ? '8' : '9']: this.plan.bwUrl
          };
        }
      } else {
        formData.is_black_white = '2';
      }
      if (this.isApp) {
        if (
          crowdOrient === '1' &&
          (this.isPeople || this.isGames || this.isHobbies || this.isAppInterest)
        ) {
          formData.is_oriented = '1';
          // formData.sex = this.putRule.sexes.map(v => v.value)
          // formData.age = this.putRule.ages.map(v => v.value)
          // formData.stages_life = this.planManage.stages.map(v => v.value)
          // formData.education = this.planManage.educations.map(v => v.value)
          // formData.income = this.putRule.incomes.map(v => v.value)
          // formData.house = this.planManage.houses.map(v => v.value)
          // formData.car = this.planManage.cars.map(v => v.value)
          // formData.career = this.planManage.careers.map(v => v.value)
          formData.sex = sex;
          formData.age = age;
          // formData.stages_life = stage
          // formData.education = education
          // formData.career = career
          formData.income = income;
          // formData.house = house
          // formData.car = car

          if (this.isGames) {
            formData.game_type = game;
          }
          if (this.isAppInterest) {
            // eslint-disable-next-line camelcase
            formData.app_interest = app_interest
          }
          if (this.isHobbies) {
            //  引力资讯、NGA、A9VG，非兴趣爱好则全选
            formData.hobby = hobby;
          }
        } else {
          formData.is_oriented = '2';
        }

        if (this.isDevice && deviceOrient === '1') {
          formData.media_ids = devices;
        } else {
          formData.media_ids = [];
        }
        // else {
        //   formData.media_ids = this.isAndroid ? this.putRule.androidDevices.map(v => v.value) : this.putRule.iosDevices.map(v => v.value)
        // }

        // formData.network_way = networkWay
        // formData.operator = operator
        // formData.network_way = this.planManage.networkWays.map(v => v.value)
        // formData.operator = this.planManage.operators.map(v => v.value)
      }
      return formData;
    },
    submitForm(numberValidateForm, next) {
      this.$refs[numberValidateForm].validate(async valid => {
        let formData = this.getSubmitParams();
        if (formData && valid) {
          this.next = next;
          this.committing = true;
          try {
            let data;
            if (this.$route.params.id && !this.isCopy) {
              data = await this.$store.dispatch('plan/updateAds', {
                platform: this.platform,
                data: formData,
                ad: this.$route.params.id
              });
            } else {
              data = await this.$store.dispatch('plan/addAds', {
                platform: this.platform,
                data: formData
              });
            }
            if (data.code === 1) {
              this.committing = true;
              tip(
                `${
                  this.$route.params.id
                    ? this.isCopy
                      ? '复制'
                      : '编辑'
                    : '添加'
                }计划成功`,
                { type: 'success' },
                () => {
                  this.$router.push({
                    path: next ? '/creation/add' : '/plans'
                  });
                }
              );
            } else {
              this.committing = false;
              tip(`${this.$route.params.id ? this.isCopy ? '复制' : '编辑' : '添加'}计划失败: ${data.msg}`
              )
            }
          } catch (error) {
            this.committing = false;
          } finally {
            this.submiting = false;
          }
        }
      });
    },
    cancel() {
      this.$router.push({ path: '/plans' });
    }
  },
  components: {
    headPanel,
    NySelect,
    NyRegionPicker,
    NyFormItemRadio,
    NyFormItemCheckbox,
    dateRange2,
    NyFormItemInput,
    NyUpload,
    treeTransfer
  }
};
</script>

<style lang="scss">
@include b(ad-plan-edit) {
  .form-title {
    font-size: 16px;
    margin: 30px 50px;
    font-weight: bold;
    color: #1d2b36;
    padding-bottom: 10px;
    border-bottom: 1px solid #ccc;
  }
  .icon-iconfontquestion {
    position: absolute;
    top: 1px;
    left: -10px;
    color: #fc8675;
    cursor: pointer;
  }
  @include e(bw) {
    margin-bottom: 22px;
  }

  @include e(upload-bw) {
    position: relative;
    margin-bottom: 4px;
  }

  @include e(upload-tip) {
    margin-left: 12%;
    color: #ff4949;
  }

  @include e(upload) {
    display: inline-block;

    .el-upload {
      text-align: left;
    }
  }
  @include e(upload-url) {
    margin-left: 10px;
  }

  @include e(upload-temp) {
    margin-left: 3px;
    font-size: 12px;
    color: #4990e2;
    cursor: pointer;
  }
  @include b(ny-device) {
    margin-left: 12%;
    margin-bottom: 22px;

    .el-transfer-panel {
      width: 348px;

      .el-input {
        width: 100%;
      }
    }
    .el-transfer-panel__filter {
      margin: 0px;
      margin-top: 10px;
      padding: 0 10px;
    }
    .el-transfer__buttons {
      padding: 0 23px;
      .el-button {
        width: 84px;
        height: 28px;
        margin: 0;
        display: block;
        &:first-child {
          margin-bottom: 6px;
        }
      }
    }

    .el-transfer-panel__item {
      &.el-checkbox {
        display: block;
      }
    }
  }

  @include b(ny-crowd) {
    position: relative;
    margin-left: 12%;
    margin-bottom: 22px;
    padding: 0px 0 10px 12px;
    background: #f9f9f9;

    h3 {
      line-height: 32px;
    }

    @include e(list) {
      margin-left: 40px;
    }

    @include e(item) {
      margin-bottom: 10px;
      overflow: hidden;

      &:last-child {
        margin-bottom: 0;
      }

      .el-form-item {
        margin-bottom: 0;
      }

      .el-form-item__content {
        margin-left: 0 !important;
      }

      .ny-form-item__checkbox {
        float: left;
        width: 702px;
      }

      .ny-form-item__checkgroup {
        width: auto;
      }
    }
    @include e(type) {
      float: left;
      width: 120px;
      height: 28px;
      line-height: 28px;
    }
  }
  @include e(nga) {
    max-width: 816px;
    .custom-tree-node{
      margin-left: 10px;
    }
  }
}
</style>
